export default {
  title: {
    information: 'Informations',
    confirmation: 'Confirmation nécessaire'
  },
  confirmAction: 'Êtes-vous certain de vouloir effectuer cette action ?',
  reconnect: 'Se reconnecter'
}
